import { Component, HostListener, OnInit } from '@angular/core';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { OrderService } from '../../../../core/services/order.service';
import { IGetOrderInvoiceDetailsBody, IGetOrderShipmentDetailsBody, IOrderInquiry, IGetOrdersDetailsBody, ICustomer, Customer, IUser, IOrderInquiryDetails, IInvoiceInquiryDetails, ITrackShipment, IOrderDetailsHeader, IGetInvoiceDetailsBody, IOrderInquiryDetailsLbl } from '../../../../core/models';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { GridSettings } from '../../../../core/common';
import { formatDate, CurrencyPipe } from '@angular/common';
import { CommonService } from '../../../../core/services/common.service';
import { UserService } from '../../../../core/services/user.service';
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
import { StatePersistingService } from '../../../../core/services/state-persisting.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { forEach } from 'lodash';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {
  public position = 'top';
  public position4 = 'left';
  orderDetailsTabGridData: GridDataResult;
  invoiceDetailsTabGridData: GridDataResult;
  trackShipmentTabGridData: GridDataResult;
  public orderDetailsGridData: IOrderInquiryDetails[] = [];
  public invoiceDetailsGridData: IInvoiceInquiryDetails[] = [];
  public invoiceDetailsGridAllData: IInvoiceInquiryDetails[] = [];
  public trackShipmentGridData: ITrackShipment[] = [];
  orderDetailsLoading: boolean;
  OrderDetailsData: IOrderInquiry;
  orderDetailsHeaderData: IOrderDetailsHeader;
  billingAddress: ICustomer;
  shippingAddress: ICustomer;
  isBillingAddress: boolean;
  isShippingAddress: boolean;
  isInvoicedetails: boolean;
  isTrackShipment: boolean;
  statusData = [];
  loadingPDF: boolean;
  loadingExcel: boolean;
  invoiceNumberList: any = [];
  invoiceNum: any;
  loadingRelatedInvoices: boolean;
  invoiceHeaderInfo: any;
  hasInvoiceInquiryAccess: boolean;
  scrHeight: any;
  scrWidth: any;
  constructor(private orderService: OrderService, private router: Router,
    private route: ActivatedRoute, private commonService: CommonService, private userService: UserService, private persistingService: StatePersistingService, private languageTranslationService: LanguageTranslationService,
    private cp: CurrencyPipe) {
    this.getScreenSize();

    const gridSettings: GridSettings = this.persistingService.get(this.loggedInUser.userName
      + 'orderDetailsGridSettings');
    if (gridSettings !== null) {
      this.gridSettings = this.mapGridSettings(gridSettings);
    }
    const gridInvoiceSettings: GridSettings = this.persistingService.get(this.loggedInUser.userName
      + 'invoiceDetailsGridSettings');
    if (gridInvoiceSettings !== null) {
      this.gridInvoiceSettings.state = this.invoiceDetailsGridstate;
      this.gridInvoiceSettings = this.invoiceMapGridSettings(gridInvoiceSettings);
    }
    const gridShipmentSettings: GridSettings = this.persistingService.get(this.loggedInUser.userName
      + 'trackShipmentGridSettings');
    if (gridShipmentSettings !== null) {
      this.gridShipmentSettings.state = this.trackShipmentGridstate;
      this.gridShipmentSettings = this.invoiceMapGridSettings(gridShipmentSettings);
    }
  }


  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    if (this.scrWidth <= 1024) {
      this.position4 = 'top';
    }
    else {
      this.position4 = 'left';
    }
  }

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.OrderDetailsData = this.orderService.getOrderInquiryData();
    if (this.OrderDetailsData === undefined || this.OrderDetailsData === null) {
      this.router.navigate(['../'], { relativeTo: this.route });
    } else {
      this.loadOrderDetailsHeader();
      this.loadOrderDetailsTabGrid();
      this.isBillingAddress = false;
      this.isShippingAddress = false;
      this.isInvoicedetails = false;
      this.isTrackShipment = false;
    }
    //this.statusData = [{ name: 'Active', value: 'Active' }, { name: 'Expired', value: 'Expired' }]
    this.checkInvoiceInquiryAccessForLoggedInUser();
  }

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "orderHeaderLbl" },
      { controlName: "billingAddressLbl" },
      { controlName: "shippingAddressLbl" },
      { controlName: "soLbl" },
      { controlName: "poLbl" },
      { controlName: "shippingFromLbl" },
      { controlName: "jobNumberLbl" },
      { controlName: "OrderDateLbl" },
      { controlName: "orderDetailsLbl" },
      { controlName: "invoiceDetailsLbl" },
      { controlName: "trackShipmentLbl" },
      { controlName: "exportToPdfLbl" },
      { controlName: "exportToExcelLbl" },
      { controlName: "statusLbl" },
      { controlName: "lineLbl" },
      { controlName: "orderDateLbl" },
      { controlName: "scheduleDateLbl" },
      { controlName: "qtyLbl" },
      { controlName: "uomLbl" },
      { controlName: "itemLbl" },
      { controlName: "paintLbl" },
      { controlName: "listPriceLbl" },
      { controlName: "itemDescLbl" },
      { controlName: "multiplierLbl" },
      { controlName: "shipDateLbl" },
      { controlName: "invoiceNumberLbl" },
      { controlName: "orderTypeLbl" },
      { controlName: "descriptionLbl" },
      { controlName: "unitPriceLbl" },
      { controlName: "extendedPriceLbl" },
      { controlName: "shipFromLbl" },
      { controlName: "shipmentIdLbl" },
      { controlName: "carrierLbl" },
      { controlName: "proNoLbl" },
      { controlName: "billOfLading" },
      { controlName: "noOfBoxesLbl" },
      { controlName: "totalWeightLbl" },
      { controlName: "cscNameLbl" },
      { controlName: "cscPhoneLbl" },
      { controlName: "totalPriceLbl" },
      { controlName: "grossAmountLbl" },
      { controlName: "taxableAmountLbl" },
      { controlName: "invoiceDateLbl" },
      { controlName: "openAmountLbl" },
      { controlName: "taxLbl" },
      { controlName: "nonTaxableLbl" },
      { controlName: "kdRefLbl" },
      { controlName: "relatedInvoiceLbl" },
    ];
    const componentName = "OrderInquiryDetails";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.orderDetailTxt = response[response.length - 1];
      console.log(response);
      this.initializeGridHeader();
    }
  }
  //#endregion
  //#region label declaration
  public orderDetail = {
    orderHeaderLbl: 'Order Header',
    billingAddressLbl: 'Billing Address',
    shippingAddressLbl: 'Shipping Address',
    soLbl: 'SO #',
    poLbl: 'PO #',
    shippingFromLbl: 'Shipping From',
    jobNumberLbl: 'Job Number',
    jobNameLbl: 'Job Name',
    cscNameLbl: 'CSC Name',
    cscPhoneLbl: 'CSC Phone',
    OrderDateLbl: 'Order Date',
    orderDetailsLbl: 'Order Details',
    invoiceDetailsLbl: 'Invoice Details',
    trackShipmentLbl: 'Track Shipments',
    exportToPdfLbl: 'Export to PDF',
    exportToExcelLbl: 'Export to Excel',
    lineLbl: 'Line #',
    orderDateLbl: 'Order Date',
    scheduleDateLbl: 'Schedule Date',
    qtyLbl: 'Qty',
    uomLbl: 'UoM',
    itemLbl: 'Item #',
    paintLbl: 'Paint Code',
    listPriceLbl: 'Unit List Price',
    itemDescLbl: 'Item Desc',
    multiplierLbl: 'Multiplier',
    statusLbl: 'Status',
    shipDateLbl: 'Ship Date',
    invoiceNumberLbl: 'Invoice #',
    orderTypeLbl: 'Order Type',
    descriptionLbl: 'Description',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    shipFromLbl: 'Ship From',
    shipmentIdLbl: 'Shipment ID',
    carrierLbl: 'Carrier',
    proNoLbl: 'Pro No.',
    billOfLading: 'Bill Of Lading',
    noOfBoxesLbl: 'No.Of Boxes',
    totalWeightLbl: 'Total Weight',
    totalPriceLbl: 'Total Price',
    grossAmountLbl: 'Gross Amount',
    taxableAmountLbl: 'Taxable Amount',
    invoiceDateLbl: 'Invoice Date',
    openAmountLbl: 'Open Amount',
    taxLbl: 'Tax',
    nonTaxableLbl: 'Non-Taxable Amount',
    kdRefLbl: 'KD Reference Number',
    customerNumberLbl: 'Customer Number',
    relatedInvoiceLbl: 'Related Invoices',
    customerNameLbl: 'Customer Name',
  };

  orderDetailTxt: IOrderInquiryDetailsLbl = {
    orderHeaderLbl: '',
    billingAddressLbl: '',
    shippingAddressLbl: '',
    soLbl: '',
    poLbl: '',
    shippingFromLbl: '',
    jobNumberLbl: '',
    OrderDateLbl: '',
    orderDetailsLbl: '',
    invoiceDetailsLbl: '',
    trackShipmentLbl: '',
    exportToPdfLbl: '',
    exportToExcelLbl: '',
    lineLbl: '',
    orderDateLbl: '',
    scheduleDateLbl: '',
    qtyLbl: '',
    uomLbl: '',
    itemLbl: '',
    paintLbl: '',
    listPriceLbl: '',
    itemDescLbl: '',
    multiplierLbl: '',
    statusLbl: '',
    shipDateLbl: '',
    invoiceNumberLbl: '',
    orderTypeLbl: '',
    descriptionLbl: '',
    unitPriceLbl: '',
    extendedPriceLbl: '',
    shipFromLbl: '',
    shipmentIdLbl: '',
    carrierLbl: '',
    proNoLbl: '',
    billOfLading: '',
    noOfBoxesLbl: '',
    totalWeightLbl: '',
    cscNameLbl: '',
    cscPhoneLbl: '',
    totalPriceLbl: '',
    grossAmountLbl: '',
    taxableAmountLbl: '',
    invoiceDateLbl: '',
    openAmountLbl: '',
    taxLbl: '',
    nonTaxableLbl: '',
    kdRefLbl: '',
    customerNumberLbl: '',
    customerNameLbl: '',
    relatedInvoiceLbl: '',
  }
  //#endregion
  public get loggedInUser(): IUser {
    return this.userService.readUserObject;
  }
  loadOrderDetailsHeader() {
    const body = {
      orderNumber: this.OrderDetailsData.orderNumber.toString(),
      orderBu: this.OrderDetailsData.orderBu,
      orderType: this.OrderDetailsData.orderType
    }
    this.orderService.getOrderDetailsHeader(body as IGetOrdersDetailsBody).subscribe((response: IOrderDetailsHeader) => {
      //this.orderDetailsLoading = false;
      if (response) {
        this.orderDetailsHeaderData = response;
      }

    })
  }
  //#region Grid filter dropdown

  //#region billing and shipping address
  onHeaderTabSelected(event) {

    //index 1 is for billing address and index 2 is for shipping address
    if (event.index == 1) {
      if (this.isBillingAddress == false) {
        this.loadAddressData(this.orderDetailsHeaderData.billTo, 'billing');
      }
    } else if (event.index == 2) {
      if (this.isShippingAddress == false) {
        this.loadAddressData(this.orderDetailsHeaderData.shipTo, 'shipping');
      }
    }
  }

  loadAddressData(id, type) {
    this.orderService.getAddress(id as number).subscribe((response: ICustomer) => {
      if (type == 'billing') {
        this.billingAddress = response;
        this.isBillingAddress = true;
      } else {
        this.shippingAddress = response;
        this.isShippingAddress = true;
      }
    })
  }
  public addressLabel = {
    billingAddressLbl: 'Billing Address',
    shippingAddressLbl: 'Shipping Address'
  }
  //#endregion

  //region details grid tab select Api call
  onDetailsGridTabSelected(event) {
    //console.log(event);
    if (event.index == 1) {
      if (this.isInvoicedetails == false) {
        if (this.hasInvoiceInquiryAccess) { this.loadInvoiceDetailsTabGrid(); }
        else { this.loadTrackShipmentTabGrid(); }

      }
    } else if (event.index == 2) {
      if (this.isTrackShipment == false) {
        this.loadTrackShipmentTabGrid();
      }
    }
  }
  //#endregion


  //#region Order details tab operations
  public loadOrderDetailsTabGrid(): void {
    this.orderDetailsLoading = true;
    const body = {
      orderNumber: this.OrderDetailsData.orderNumber.toString(),
      orderBu: this.OrderDetailsData.orderBu,
      orderType: this.OrderDetailsData.orderType
    }
    this.orderService.getOrderDetail(body as IGetOrdersDetailsBody).subscribe((response: Array<IOrderInquiryDetails>) => {
      this.orderDetailsLoading = false;
      if (response) {
        this.orderDetailsGridData = response.map((obj) => {
          obj.scheduleDateAsDate = obj.scheduleDateUIString ? new Date(obj.scheduleDateUIString) : null;
          obj.shipDateAsDate = obj.shipDateUIString ? new Date(obj.shipDateUIString) : null;
          obj.orderDateAsDate = obj.orderDateUIString ? new Date(obj.orderDateUIString) : null;
          return obj;
        });
        //this.statusData = this.orderDetailsGridData.map(r => {
        //  return { name: r.status, status: r.status };
        //}).filter(
        //  (thing, i, arr) => arr.findIndex(t => t.status === thing.status) === i //remove duplicate
        //);
        ////console.log(response);
        this.statusData =
          [{ name: 'Received', status: 'Received -Date Pending' },
          { name: 'Open', status: 'Open Order' },
          { name: 'Shipped', status: 'Shipped' },
          { name: 'BackOrdered', status: 'BackOrdered Matâ€™l' },
          { name: 'Canceled', status: 'Canceled' }];
        this.loadOrderDetailsGridData();
      }

    }, error => {
      this.orderDetailsLoading = false;
    })
  }
  public orderDetailsTabGridColumnLbl = {
    line: 'Line #',
    scheduleDate: 'Schedule Date',
    item: 'Item #',
    qty: 'Qty',
    uom: 'UOM',
    orderDate: 'Order Date',
    paint: 'Paint Code',
    itemDecription: 'Item Desc',
    status: 'Status',
    shipDate: 'Ship Date',
    listPrice: 'List Price',
    multiplier: 'Multiplier',
    unitPrice: 'Unit Price',
    extendedPrice: 'Ext. Price',

  };

  //#region pagination, sorting,filtering for order details grid

  public orderDetailsGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'orderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };


  public loadOrderDetailsGridData(): void {
    this.orderDetailsTabGridData = process(this.orderDetailsGridData, this.orderDetailsGridstate);
  }

  public orderDetailsGridSortChange(sort): void {
    this.orderDetailsGridstate.sort = sort;
    this.loadOrderDetailsGridData();
  }

  public orderDetailsGridPageChange({ skip, take }: PageChangeEvent): void {
    this.orderDetailsGridstate.skip = skip;
    this.orderDetailsGridstate.take;
    this.loadOrderDetailsGridData();
  }

  public orderDetailsDataStateChange(state: DataStateChangeEvent): void {
    this.orderDetailsGridstate = state;
    this.loadOrderDetailsGridData();
  }

  //#endregion

  //#region column chooser localstoage save
  public gridSettings: GridSettings = {
    state: this.orderDetailsGridstate,
    gridData: process(this.orderDetailsGridData, this.orderDetailsGridstate),
    columnsConfig: [{
      field: 'lineNumber',
      title: this.orderDetailTxt.lineLbl ? this.orderDetailTxt.lineLbl : this.orderDetail.lineLbl,
      filterable: true
    }, {
      field: 'scheduleDateAsDate',
      title: this.orderDetailTxt.scheduleDateLbl ? this.orderDetailTxt.scheduleDateLbl : this.orderDetail.scheduleDateLbl,
      _width: 220,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    },
    {
      field: 'itemNumber',
      title: this.orderDetailTxt.itemLbl ? this.orderDetailTxt.itemLbl : this.orderDetail.itemLbl,
      filterable: true
    }
      ,
    {
      field: 'quantity',
      title: this.orderDetailTxt.qtyLbl ? this.orderDetailTxt.qtyLbl : this.orderDetail.qtyLbl,
      filterable: true
    },
    {
      field: 'uom',
      title: this.orderDetailTxt.uomLbl ? this.orderDetailTxt.uomLbl : this.orderDetail.uomLbl,
      filterable: true
    },
    {
      field: 'orderDateAsDate',
      title: this.orderDetailTxt.orderDateLbl ? this.orderDetailTxt.orderDateLbl : this.orderDetail.orderDateLbl,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    },
    {
      field: 'paint',
      title: this.orderDetailTxt.paintLbl ? this.orderDetailTxt.paintLbl : this.orderDetail.paintLbl,
      filterable: true
    },
    {
      field: 'description',
      title: this.orderDetailTxt.itemDescLbl ? this.orderDetailTxt.itemDescLbl : this.orderDetail.itemDescLbl,
      filterable: true
    },
    {
      field: 'status',
      title: this.orderDetailTxt.statusLbl ? this.orderDetailTxt.statusLbl : this.orderDetail.statusLbl,
      filterable: true
    },
    {
      field: 'shipDateAsDate',
      title: this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    },

    {
      field: 'listPrice',
      title: this.orderDetailTxt.listPriceLbl ? this.orderDetailTxt.listPriceLbl : this.orderDetail.listPriceLbl,
      filterable: true
    },
    {
      field: 'cmp',
      title: this.orderDetailTxt.multiplierLbl ? this.orderDetailTxt.multiplierLbl : this.orderDetail.multiplierLbl,
      filterable: true
    }

    ]
  };
  //#endregion

  //#region Export to PDF and Excel for order inquiry details grid
  async generatePDF() {

    this.loadingPDF = true;
    var currFilter = this.orderDetailsGridstate.filter;
    var filterData = process(this.orderDetailsGridData, {
      filter: currFilter
    });

    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: 'Order Details', alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          columns: [
            [{
               text: "Customer Number: " + this.loggedInUser.customerNumber,
              bold: true,
              margin: [0, 15, 0, 15]
            },
            {
              text: "Customer Name: " + this.loggedInUser.customerName,
              bold: true,
              margin: [0, 15, 0, 15]
            }],
            [{
              text: "SO#: " + this.orderDetailsHeaderData.orderNumber,
              margin: [0, 2, 0, 2]
            },
            {
              text: "PO#: " + this.OrderDetailsData.poNumber,
              margin: [0, 2, 0, 2]
              },
              {
                text: "Shipping From: " + this.OrderDetailsData.shipFrom,
                margin: [0, 2, 0, 2]
              },
              {
                text: "Job Name: " + this.orderDetailsHeaderData.jobName,
                margin: [0, 2, 0, 2]
              },
              {
                text: "Job Number: " + this.orderDetailsHeaderData.jobNumber,
                margin: [0, 2, 0, 2]
              },
              {
                text: "Order Date: " + this.orderDetailsHeaderData.orderDateUIString,
                margin: [0, 2, 0, 2]
              },
              {
                text: "CSC Name: " + this.orderDetailsHeaderData.cscName,
                margin: [0, 2, 0, 2]
              },
              {
                text: "CSC Phone: " + this.orderDetailsHeaderData.cscPhone,
                margin: [0, 2, 0, 2]
              }]
          ],
        },
        {
          text: "Order Details",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            widths: [26, 40, '*', 13, 20, 40, 40, 40, 40, 40, 30, 35],
            body: [
              [

                this.orderDetailTxt.lineLbl ? this.orderDetailTxt.lineLbl : this.orderDetail.lineLbl,
                this.orderDetailTxt.scheduleDateLbl ? this.orderDetailTxt.scheduleDateLbl : this.orderDetail.scheduleDateLbl,
                this.orderDetailTxt.itemLbl ? this.orderDetailTxt.itemLbl : this.orderDetail.itemLbl,
                this.orderDetailTxt.qtyLbl ? this.orderDetailTxt.qtyLbl : this.orderDetail.qtyLbl,
                this.orderDetailTxt.uomLbl ? this.orderDetailTxt.uomLbl : this.orderDetail.uomLbl,
                this.orderDetailTxt.orderDateLbl ? this.orderDetailTxt.orderDateLbl : this.orderDetail.orderDateLbl,
                this.orderDetailTxt.paintLbl ? this.orderDetailTxt.paintLbl : this.orderDetail.paintLbl,
                this.orderDetailTxt.itemDescLbl ? this.orderDetailTxt.itemDescLbl : this.orderDetail.itemDescLbl,
                this.orderDetailTxt.statusLbl ? this.orderDetailTxt.statusLbl : this.orderDetail.statusLbl,
                this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl,
                this.orderDetailTxt.listPriceLbl ? this.orderDetailTxt.listPriceLbl : this.orderDetail.listPriceLbl,
                this.orderDetailTxt.multiplierLbl ? this.orderDetailTxt.multiplierLbl : this.orderDetail.multiplierLbl],
              ...filterData.data.map(p =>
                ([
                  p.lineNumber,
                  p.scheduleDateUIString ? p.scheduleDateUIString : '',
                  p.itemNumber ? p.itemNumber : '',
                  p.quantity ? p.quantity : '',
                  p.uom ? p.uom : '',
                  p.orderDateUIString ? p.orderDateUIString : '',
                  p.paint ? p.paint : '',
                  p.description ? p.description : '',
                  p.status ? p.status : '',
                  p.shipDateUIString ? p.shipDateUIString : '',
                  //Note that value -0.001 has been added not to display price in pdf, do not change the value without cahnging in the backend
                  p.cmp > 0 ? ((this.orderDetailsHeaderData.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.listPrice && p.listPrice > -0.001 ? this.cp.transform(p.listPrice, 'USD', true, '1.2-2') : this.cp.transform(0, 'USD', true, '1.2-2'))) : '',
                  p.cmp ? (p.cmp > 0 ? ((this.orderDetailsHeaderData.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : p.cmp) : '') : '',
                ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('OrderDetails.pdf');
    this.loadingPDF = false;
  }

  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.orderDetailsGridstate.filter;
    var filterData = process(this.orderDetailsGridData, {
      filter: currFilter
    });

    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Order Details');
    const header = [this.orderDetailTxt.lineLbl ? this.orderDetailTxt.lineLbl : this.orderDetail.lineLbl,
    this.orderDetailTxt.scheduleDateLbl ? this.orderDetailTxt.scheduleDateLbl : this.orderDetail.scheduleDateLbl,
    this.orderDetailTxt.itemLbl ? this.orderDetailTxt.itemLbl : this.orderDetail.itemLbl,
    this.orderDetailTxt.qtyLbl ? this.orderDetailTxt.qtyLbl : this.orderDetail.qtyLbl,
    this.orderDetailTxt.uomLbl ? this.orderDetailTxt.uomLbl : this.orderDetail.uomLbl,
    this.orderDetailTxt.orderDateLbl ? this.orderDetailTxt.orderDateLbl : this.orderDetail.orderDateLbl,
    this.orderDetailTxt.paintLbl ? this.orderDetailTxt.paintLbl : this.orderDetail.paintLbl,
    this.orderDetailTxt.itemDescLbl ? this.orderDetailTxt.itemDescLbl : this.orderDetail.itemDescLbl,
    this.orderDetailTxt.statusLbl ? this.orderDetailTxt.statusLbl : this.orderDetail.statusLbl,
    this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl,
    this.orderDetailTxt.listPriceLbl ? this.orderDetailTxt.listPriceLbl : this.orderDetail.listPriceLbl,
    this.orderDetailTxt.multiplierLbl ? this.orderDetailTxt.multiplierLbl : this.orderDetail.multiplierLbl];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow(['', '', '', '', "SO#: " + this.orderDetailsHeaderData.orderNumber]);
    worksheet.addRow(['', '', '', '', "PO#: " + this.OrderDetailsData.poNumber]);
    worksheet.addRow(['Customer Number:' + this.loggedInUser.customerNumber + '', '', '', '', "Shipping From: " + this.OrderDetailsData.shipFrom]);
    worksheet.addRow(['', '', '', '', "Job Name: " + this.orderDetailsHeaderData.jobName]);
    worksheet.addRow(['', '', '', '', "Job Number: " + this.orderDetailsHeaderData.jobNumber]);
    worksheet.addRow(['Customer Name:' + this.loggedInUser.customerName + '', '', '', '', "Order Date: " + this.orderDetailsHeaderData.orderDateUIString]);
    worksheet.addRow(['', '', '', '', "CSC Name: " + this.orderDetailsHeaderData.cscName]);
    worksheet.addRow(['', '', '', '', "CSC Phone: " + this.orderDetailsHeaderData.cscPhone]);
    worksheet.columns[0].width = 40;
    //let ClientIdRow = worksheet.addRow(['Customer Number :' + this.loggedInUser.customerNumber + '']);
    //ClientIdRow.font = { size: 10, bold: true }
    //worksheet.addRow([]);
    //let ClientNameRow = worksheet.addRow(['Customer Name :' + this.loggedInUser.customerName + '']);
    //ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);

    let invoiceDetailsRow = worksheet.addRow(['Order Details']);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.map(p =>
      ([
        p.lineNumber,
        p.scheduleDateUIString ? p.scheduleDateUIString : '',
        p.itemNumber ? p.itemNumber : '',
        p.quantity ? p.quantity : '',
        p.uom ? p.uom : '',
        p.orderDateUIString ? p.orderDateUIString : '',
        p.paint ? p.paint : '',
        p.description ? p.description : '',
        p.status ? p.status : '',
        p.shipDateUIString ? p.shipDateUIString : '',
         //Note that value -0.001 has been added not to display price in excel, do not change the value without cahnging in the backend
        p.cmp > 0 ? ((this.orderDetailsHeaderData.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.listPrice && p.listPrice > -0.001 ? this.cp.transform(p.listPrice, 'USD', true, '1.2-2') : this.cp.transform(0, 'USD', true, '1.2-2'))) : '',
        p.cmp ? (p.cmp > 0 ? ((this.orderDetailsHeaderData.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : p.cmp) : '') : '',
      ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'OrderDetails.xlsx');
      this.loadingExcel = false;
    })
  }

  //#endregion
  //#region grid state save
  public onReorder(e: any): void {
    const reorderedColumn = this.gridSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  protected onVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.gridSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });
    this.saveGrid();
  }

  public saveGrid(): void {
    const gridConfig = {
      columnsConfig: this.gridSettings.columnsConfig,
      state: this.gridSettings.state
    };
    this.persistingService.set(this.loggedInUser.userName + 'orderDetailsGridSettings', gridConfig);
  }

  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = this.orderDetailsGridstate;//gridSettings.state;
    this.mapDateFilter(state.filter);
    state.skip = 0;
    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.orderDetailsGridData, state)
    };
  }
  public mapDateFilter = (descriptor: any) => {
    const filters = descriptor.filters || [];

    filters.forEach(filter => {
      if (filter.filters) {
        this.mapDateFilter(filter);
      }
    });
  }
  //#endregion
  //#region pwa filter for order details

  public onFilterOrderInquiryDetails(inputValue: string): void {
    if (this.orderDetailsGridData.length > 0) {
      this.orderDetailsTabGridData = process(this.orderDetailsGridData, {
        filter: {
          logic: "or",
          filters: [
            {
              field: "scheduleDateUIString",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "itemNumber",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "quantity",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "uom",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "orderDateUIString",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "paint",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "description",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "status",
              operator: "contains",
              value: inputValue,
            },

            {
              field: "shipDateUIString",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "listPrice",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "cmp",
              operator: "contains",
              value: inputValue,
            }
          ],
        },
      });
      if (!inputValue) {
        this.orderDetailsGridstate.skip = 0;
        this.orderDetailsGridstate.take = 10;
        this.loadOrderDetailsGridData();
      }
    }

  }
  //#endregion
  //#endregion
  invoiceDetailsLoading: boolean;
  //#region Invoice details tab operations
  public loadInvoiceDetailsTabGrid(): void {
    //change method name
    const body = {
      orderNumber: this.OrderDetailsData.orderNumber.toString(),
      orderBu: this.OrderDetailsData.orderBu,
      orderType: this.OrderDetailsData.orderType
    }
    this.invoiceDetailsLoading = true;
    this.orderService.getOrderInvoiceDetail(body as IGetOrderInvoiceDetailsBody).subscribe((response: Array<IInvoiceInquiryDetails>) => {

      this.invoiceDetailsLoading = false;
      if (response) {
        this.relatedInvoiceData(response);//invoice header related invoice dropdown data
        this.invoiceDetailsGridAllData = response;
        this.invoiceDetailsGridData = this.invoiceDetailsGridAllData.filter(r => r.invoiceNumber == this.invoiceNum.invoiceNumber);// filter data based on dropdown value
        this.invoiceHeaderInfo = this.invoiceDetailsGridData[0];
        this.loadInvoiceDetailsGridData();
      }
      this.isInvoicedetails = true;
    }, error => {
      this.invoiceDetailsLoading = false;
      this.isInvoicedetails = true;
    })
  }
  //#region invoice number dropdown
  relatedInvoiceData(response: IInvoiceInquiryDetails[]) {
    if (response.length > 0) {
      this.loadingRelatedInvoices = true;
      this.invoiceNum = { invoiceNumber: (Number)(response[0].invoiceNumber) };
      const body = {
        invoiceNumber: response[0].invoiceNumber.toString(),
        orderBu: this.OrderDetailsData.orderBu,
        orderNumber: this.OrderDetailsData.orderNumber.toString(),
        orderType: this.OrderDetailsData.orderType
      }
      this.orderService.getRelatedInvoices(body as IGetInvoiceDetailsBody).subscribe((response: Array<any>) => {
        if (response) {
          this.invoiceNumberList = response;
          //  .filter(
          //  (thing, i, arr) => arr.findIndex(t => t.invoiceNumber === thing.invoiceNumber) === i
          //);
          this.loadingRelatedInvoices = false;
        }
      });
    }
    //if (response.length > 0) {
    //  this.loadingRelatedInvoices = true;
    //  this.invoiceNum = { invoiceNumber: response[0].invoiceNumber };
    //  this.invoiceNumberList = response.map(r => {
    //    return { invoiceNumber: r.invoiceNumber };
    //  }).filter(
    //    (thing, i, arr) => arr.findIndex(t => t.invoiceNumber === thing.invoiceNumber) === i //remove duplicate invoice number
    //  );
    //  this.loadingRelatedInvoices = false;
    //}
  }
  invoiceNumberChange() {
    if (this.invoiceNum.invoiceNumber) {
      this.invoiceDetailsGridData = this.invoiceDetailsGridAllData.filter(r => r.invoiceNumber == this.invoiceNum.invoiceNumber);// filter data based on dropdown value
      this.invoiceHeaderInfo = this.invoiceDetailsGridData[0];
      this.loadInvoiceDetailsGridData();
    }
  }
  //#endregion
  public invoiceDetailsTabGridColumnLbl = {
    invoice: 'Invoice #',
    line: 'Line #',
    orderType: 'Order Type',
    qty: 'Qty',
    uom: 'UOM',
    item: 'Item#',
    description: 'Description',
    unitPrice: 'Unit Price',
    extendedPrice: 'Extended Price',
    shipFrom: 'Ship From',
    status: 'Status'
  };

  //#region pagination, sorting,filtering for order details grid

  public invoiceDetailsGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'orderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public loadInvoiceDetailsGridData(): void {
    this.invoiceDetailsTabGridData = process(this.invoiceDetailsGridData, this.invoiceDetailsGridstate);
  }

  public invoiceDetailsGridSortChange(sort): void {
    this.invoiceDetailsGridstate.sort = sort;
    this.loadInvoiceDetailsGridData();
  }

  public invoiceDetailsGridPageChange({ skip, take }: PageChangeEvent): void {
    this.invoiceDetailsGridstate.skip = skip;
    this.invoiceDetailsGridstate.take;
    this.loadInvoiceDetailsGridData();
  }

  public invoiceDetailsDataStateChange(state: DataStateChangeEvent): void {
    this.invoiceDetailsGridstate = state;
    this.loadInvoiceDetailsGridData();
  }

  //#endregion

  //#region column chooser localstoage save
  public gridInvoiceSettings: GridSettings = {
    state: this.orderDetailsGridstate,
    gridData: process(this.invoiceDetailsGridData, this.invoiceDetailsGridstate),
    columnsConfig: [{
      field: 'invoiceNumber',
      title: this.orderDetailTxt.invoiceNumberLbl ? this.orderDetailTxt.invoiceNumberLbl : this.orderDetail.invoiceNumberLbl,
      filterable: true
    },
    {
      field: 'lineNumber',
      title: this.orderDetailTxt.lineLbl ? this.orderDetailTxt.lineLbl : this.orderDetail.lineLbl,
      filterable: true
    },
    {
      field: 'orderType',
      title: this.orderDetailTxt.orderTypeLbl ? this.orderDetailTxt.orderTypeLbl : this.orderDetail.orderTypeLbl,
      filterable: true
    },
    {
      field: 'quantity',
      title: this.orderDetailTxt.qtyLbl ? this.orderDetailTxt.qtyLbl : this.orderDetail.qtyLbl,
      filterable: true
    },
    {
      field: 'uom',
      title: this.orderDetailTxt.uomLbl ? this.orderDetailTxt.uomLbl : this.orderDetail.uomLbl,
      filterable: true
    },
    {
      field: 'itemNumber',
      title: this.orderDetailTxt.itemLbl ? this.orderDetailTxt.itemLbl : this.orderDetail.itemLbl,
      filterable: true
    },
    {
      field: 'itemDescription',
      title: this.orderDetailTxt.descriptionLbl ? this.orderDetailTxt.descriptionLbl : this.orderDetail.descriptionLbl,
      filterable: true
    },
    {
      field: 'unitPrice',
      title: this.orderDetailTxt.unitPriceLbl ? this.orderDetailTxt.unitPriceLbl : this.orderDetail.unitPriceLbl,
      filterable: true
    },
    {
      field: 'extendedPrice',
      title: this.orderDetailTxt.extendedPriceLbl ? this.orderDetailTxt.extendedPriceLbl : this.orderDetail.extendedPriceLbl,
      filterable: true
    },

    {
      field: 'shipFrom',
      title: this.orderDetailTxt.shipFromLbl ? this.orderDetailTxt.shipFromLbl : this.orderDetail.shipFromLbl,
      filterable: true
    },
    {
      field: 'status',
      title: this.orderDetailTxt.statusLbl ? this.orderDetailTxt.statusLbl : this.orderDetail.statusLbl,
      filterable: true
    }

    ]
  };
  //#endregion

  //#region Export to PDF and Excel for invoice inquiry details grid
  async generateInvoicePDF() {
    this.loadingPDF = true;
    var currFilter = this.invoiceDetailsGridstate.filter;
    var filterData = process(this.invoiceDetailsGridData, {
      filter: currFilter
    });
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: 'Invoice Details', alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          columns: [
            [{
              text: "Customer Number: " + this.loggedInUser.customerNumber,
              bold: true,
              margin: [0, 15, 0, 15]
            },
            {
              text: "Customer Name: " + this.loggedInUser.customerName,
              bold: true,
              margin: [0, 15, 0, 15]
            }],
            [{
              text: "Invoice#: " + ((this.invoiceHeaderInfo != undefined) ? this.invoiceHeaderInfo.invoiceNumber : ''),
              margin: [0, 2, 0, 2]
            },
            {
              text: "Gross Amount: " + this.commonService.formatCurrencyTwodigit(((this.invoiceHeaderInfo != undefined) ? this.invoiceHeaderInfo.grossAmount: 0)),
              margin: [0, 2, 0, 2]
            },
            {
              text: "Taxable Amount: " + this.commonService.formatCurrencyTwodigit(((this.invoiceHeaderInfo != undefined) ? this.invoiceHeaderInfo.taxableAmount: 0)),
              margin: [0, 2, 0, 2]
            },
              {
                text: "Invoice Date: " + ((this.invoiceHeaderInfo != undefined) ? this.invoiceHeaderInfo.invoiceDateUIString : ''),
              margin: [0, 2, 0, 2]
            },
            {
              text: "Open Amount: " + this.commonService.formatCurrencyTwodigit(((this.invoiceHeaderInfo != undefined) ?this.invoiceHeaderInfo.openAmount: 0)),
              margin: [0, 2, 0, 2]
            },
            {
              text: "Tax: " + this.commonService.formatCurrencyTwodigit(((this.invoiceHeaderInfo != undefined) ?this.invoiceHeaderInfo.tax : 0)),
              margin: [0, 2, 0, 2]
            },
            {
              text: "KD Reference Number: " + ((this.invoiceHeaderInfo != undefined) ? this.invoiceHeaderInfo.kdReferenceNumber: ''),
              margin: [0, 2, 0, 2]
             },
              {
                text: "Non-Taxable Amount: " + this.commonService.formatCurrencyTwodigit(((this.invoiceHeaderInfo != undefined) ?this.invoiceHeaderInfo.nonTaxableAmount : 0)),
                margin: [0, 2, 0, 2]
              },
              {
                text: "Related Invoices: " + (this.invoiceNum != undefined ? this.invoiceNum.invoiceNumber : ''),
                margin: [0, 2, 0, 2]
              }
            ]
          ],
        },
        {
          text: "Invoice Details",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            widths: [50, 30, 30, 20, 30, 50, 50, 30, 40, 50, 50],
            body: [
              [
                this.orderDetailTxt.invoiceNumberLbl ? this.orderDetailTxt.invoiceNumberLbl : this.orderDetail.invoiceNumberLbl,
                this.orderDetailTxt.lineLbl ? this.orderDetailTxt.lineLbl : this.orderDetail.lineLbl,
                this.orderDetailTxt.orderTypeLbl ? this.orderDetailTxt.orderTypeLbl : this.orderDetail.orderTypeLbl,
                this.orderDetailTxt.qtyLbl ? this.orderDetailTxt.qtyLbl : this.orderDetail.qtyLbl,
                this.orderDetailTxt.invoiceNumberLbl ? this.orderDetailTxt.invoiceNumberLbl : this.orderDetail.uomLbl,
                this.orderDetailTxt.itemLbl ? this.orderDetailTxt.itemLbl : this.orderDetail.itemLbl,
                this.orderDetailTxt.descriptionLbl ? this.orderDetailTxt.descriptionLbl : this.orderDetail.descriptionLbl,
                this.orderDetailTxt.unitPriceLbl ? this.orderDetailTxt.unitPriceLbl : this.orderDetail.unitPriceLbl,
                this.orderDetailTxt.extendedPriceLbl ? this.orderDetailTxt.extendedPriceLbl : this.orderDetail.extendedPriceLbl,
                this.orderDetailTxt.shipFromLbl ? this.orderDetailTxt.shipFromLbl : this.orderDetail.shipFromLbl,
                this.orderDetailTxt.statusLbl ? this.orderDetailTxt.statusLbl : this.orderDetail.statusLbl],
              ...filterData.data.map(p =>
              ([
                p.invoiceNumber ? p.invoiceNumber : '',
                p.lineNumber ? p.lineNumber : '',
                p.orderType ? p.orderType : '',
                p.quantity ? p.quantity : '',
                p.uom ? p.uom : '',
                p.itemNumber ? p.itemNumber : '',
                p.itemDescription ? p.itemDescription : '',
                (p.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.unitPrice ? p.unitPrice : ''),
                (p.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.extendedPrice ? p.extendedPrice : ''),
                p.shipFrom ? p.shipFrom : '',
                p.status ? p.status : '',
              ])
              )
            ]
          }

        }
      ],
      footer: {
        columns: [
          { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('InvoiceDetails.pdf');
    this.loadingPDF = false;
  }

  generateInvoiceExcel() {
    this.loadingExcel = true;
    var currFilter = this.invoiceDetailsGridstate.filter;
    var filterData = process(this.invoiceDetailsGridData, {
      filter: currFilter
    });

    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Order Details');
    const header = [
      this.orderDetailTxt.invoiceNumberLbl ? this.orderDetailTxt.invoiceNumberLbl : this.orderDetail.invoiceNumberLbl,
      this.orderDetailTxt.lineLbl ? this.orderDetailTxt.lineLbl : this.orderDetail.lineLbl,
      this.orderDetailTxt.orderTypeLbl ? this.orderDetailTxt.orderTypeLbl : this.orderDetail.orderTypeLbl,
      this.orderDetailTxt.qtyLbl ? this.orderDetailTxt.qtyLbl : this.orderDetail.qtyLbl,
      this.orderDetailTxt.invoiceNumberLbl ? this.orderDetailTxt.invoiceNumberLbl : this.orderDetail.uomLbl,
      this.orderDetailTxt.itemLbl ? this.orderDetailTxt.itemLbl : this.orderDetail.itemLbl,
      this.orderDetailTxt.descriptionLbl ? this.orderDetailTxt.descriptionLbl : this.orderDetail.descriptionLbl,
      this.orderDetailTxt.unitPriceLbl ? this.orderDetailTxt.unitPriceLbl : this.orderDetail.unitPriceLbl,
      this.orderDetailTxt.extendedPriceLbl ? this.orderDetailTxt.extendedPriceLbl : this.orderDetail.extendedPriceLbl,
      this.orderDetailTxt.shipFromLbl ? this.orderDetailTxt.shipFromLbl : this.orderDetail.shipFromLbl,
      this.orderDetailTxt.statusLbl ? this.orderDetailTxt.statusLbl : this.orderDetail.statusLbl];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow(['', '', '', '', "Invoice#: " + this.invoiceHeaderInfo.invoiceNumber]);
    worksheet.addRow(['', '', '', '', "Gross Amount: " + this.commonService.formatCurrencyTwodigit(this.invoiceHeaderInfo.grossAmount)]);
    worksheet.addRow(['Customer Number:' + this.loggedInUser.customerNumber + '', '', '', '', "Taxable Amount: " + this.commonService.formatCurrencyTwodigit(this.invoiceHeaderInfo.taxableAmount)]);
    worksheet.addRow(['', '', '', '', "Invoice Date: " + this.invoiceHeaderInfo.invoiceDateUIString]);
    worksheet.addRow(['Customer Name:' + this.loggedInUser.customerName + '', '', '', '', "Open Amount: " + this.commonService.formatCurrencyTwodigit(this.invoiceHeaderInfo.openAmount)]);
    worksheet.addRow(['', '', '', '', "Tax: " + this.commonService.formatCurrencyTwodigit(this.invoiceHeaderInfo.tax)]);
    worksheet.addRow(['', '', '', '', "KD Reference Number: " + this.invoiceHeaderInfo.kdReferenceNumber]);
    worksheet.addRow(['', '', '', '', "Non-Taxable Amount: " + this.commonService.formatCurrencyTwodigit(this.invoiceHeaderInfo.nonTaxableAmount)]);
    worksheet.addRow(['', '', '', '', "Related Invoices: " + this.invoiceNum.invoiceNumber]);
    worksheet.columns[0].width = 40;
    //let ClientIdRow = worksheet.addRow(['Customer Number :' + this.loggedInUser.customerNumber + '']);
    //ClientIdRow.font = { size: 10, bold: true }
    //worksheet.addRow([]);
    //let ClientNameRow = worksheet.addRow(['Customer Name :' + this.loggedInUser.customerName + '']);
    //ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);

    let invoiceDetailsRow = worksheet.addRow(['Invoice Details']);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.map(p =>
    ([
      p.invoiceNumber ? p.invoiceNumber : '',
      p.lineNumber ? p.lineNumber : '',
      p.orderType ? p.orderType : '',
      p.quantity ? p.quantity : '',
      p.uom ? p.uom : '',
      p.itemNumber ? p.itemNumber : '',
      p.itemDescription ? p.itemDescription : '',
      (p.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.unitPrice ? p.unitPrice : ''),
      (p.invoiceLineDetail == 'N' && p.itemNumber != 'FRT') ? '' : (p.extendedPrice ? p.extendedPrice : ''),
      p.shipFrom ? p.shipFrom : '',
      p.status ? p.status : '',
    ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'InvoiceDetails.xlsx');
    })
    this.loadingExcel = false;
  }

  //#endregion
  //#region grid state save
  public onInvoiceReorder(e: any): void {
    const reorderedColumn = this.gridInvoiceSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridInvoiceSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  public onInvoiceVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.gridInvoiceSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });
    this.saveInvoiceGrid();
  }

  public saveInvoiceGrid(): void {
    const gridConfig = {
      columnsConfig: this.gridInvoiceSettings.columnsConfig,
      state: this.gridInvoiceSettings.state
    };
    this.persistingService.set(this.loggedInUser.userName + 'invoiceDetailsGridSettings', gridConfig);
  }

  public invoiceMapGridSettings(gridInvoiceSettings: GridSettings): GridSettings {
    const state = gridInvoiceSettings.state;
    this.mapInvoiceDateFilter(state.filter);
    state.skip = 0;
    return {
      state,
      columnsConfig: gridInvoiceSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.orderDetailsGridData, state)
    };
  }
  public mapInvoiceDateFilter = (descriptor: any) => {
    const filters = descriptor.filters || [];

    filters.forEach(filter => {
      if (filter.filters) {
        this.mapDateFilter(filter);
      }
    });
  }
  //#endregion

  //#region pwa filter for invoice details  
  public onFilterInvoiceDetails(inputValue: string): void {
    if (this.invoiceDetailsGridData.length > 0) {
      this.invoiceDetailsTabGridData = process(this.invoiceDetailsGridData, {
        filter: {
          logic: "or",
          filters: [
            {
              field: "invoiceNumber",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "lineNumber",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "orderType",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "quantity",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "uom",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "itemNumber",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "itemDescription",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "unitPrice",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "extendedPrice",
              operator: "contains",
              value: inputValue,
            },

            {
              field: "shipFrom",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "status",
              operator: "contains",
              value: inputValue,
            }
          ],
        },
      });
      if (!inputValue) {
        this.invoiceDetailsGridstate.skip = 0;
        this.invoiceDetailsGridstate.take = 10;
        this.loadInvoiceDetailsGridData();
      }
    }

  }
  //#endregion
  //#endregion

  //#region Track shipment tab operations
  trackShipmentLoading: boolean;
  public loadTrackShipmentTabGrid(): void {
    const body = {
      orderNumber: this.OrderDetailsData.orderNumber.toString(),
      orderBu: this.OrderDetailsData.orderBu as string

    }
    this.trackShipmentLoading = true;
    this.orderService.getOrderShipmentDetail(body as IGetOrderShipmentDetailsBody).subscribe((response: Array<any>) => {

      this.trackShipmentLoading = false;
      if (response) {
        this.trackShipmentGridData = response.map((obj) => {
          obj.shipDateUIString = new Date(obj.shipDateUIString);
          return obj;
        });
        this.loadTrackShipmentGridData();
      }
      this.isTrackShipment = true;

    }, error => { this.trackShipmentLoading = false; this.isTrackShipment = true; })
  }
  public trackShipmentTabGridColumnLbl = {
    shipmentId: 'Shipment ID',
    carrier: 'Carrier',
    proNo: 'Pro No.',
    billOfLoading: 'Bill Of Loading',
    noOfBoxes: 'No. Of Boxes',
    totalWeight: 'Total Weight',
    shipDate: 'Ship Date'
  };

  //#region pagination, sorting,filtering for order details grid

  public trackShipmentGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'orderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public loadTrackShipmentGridData(): void {
    this.trackShipmentTabGridData = process(this.trackShipmentGridData, this.trackShipmentGridstate);
  }

  public trackShipmentGridSortChange(sort): void {
    this.trackShipmentGridstate.sort = sort;
    this.loadTrackShipmentGridData();
  }

  public trackShipmentGridPageChange({ skip, take }: PageChangeEvent): void {
    this.trackShipmentGridstate.skip = skip;
    this.trackShipmentGridstate.take;
    this.loadTrackShipmentGridData();
  }

  public trackShipmentDataStateChange(state: DataStateChangeEvent): void {
    this.trackShipmentGridstate = state;
    this.loadTrackShipmentGridData();
  }

  //#endregion

  //#region column chooser localstoage save 
  public gridShipmentSettings: GridSettings = {
    state: this.trackShipmentGridstate,
    gridData: process(this.trackShipmentGridData, this.trackShipmentGridstate),
    columnsConfig: [{
      field: 'shipmentId',
      title: this.orderDetailTxt.shipmentIdLbl ? this.orderDetailTxt.shipmentIdLbl : this.orderDetail.shipmentIdLbl,
      filterable: true
    },
    {
      field: 'carrier',
      title: this.orderDetailTxt.carrierLbl ? this.orderDetailTxt.carrierLbl : this.orderDetail.carrierLbl,
      filterable: true
    },
    {
      field: 'proNo',
      title: this.orderDetailTxt.proNoLbl ? this.orderDetailTxt.proNoLbl : this.orderDetail.proNoLbl,
      filterable: true
    },
    {
      field: 'billOfLoading',
      title: this.orderDetailTxt.billOfLading ? this.orderDetailTxt.billOfLading : this.orderDetail.billOfLading,
      filterable: true
    },
    {
      field: 'noOfBoxes',
      title: this.orderDetailTxt.noOfBoxesLbl ? this.orderDetailTxt.noOfBoxesLbl : this.orderDetail.noOfBoxesLbl,
      filterable: true
    },
    {
      field: 'totalWeight',
      title: this.orderDetailTxt.totalWeightLbl ? this.orderDetailTxt.totalWeightLbl : this.orderDetail.totalWeightLbl,
      filterable: true
    },
    {
      field: 'shipDateUIString',
      title: this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl,
      _width: 220,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    }
    ]
  };
  //#endregion

  //#region Export to PDF and Excel for invoice inquiry details grid
  async generateShipmentPDF() {
    this.loadingPDF = true;
    var currFilter = this.trackShipmentGridstate.filter;
    var filterData = process(this.trackShipmentGridData, {
      filter: currFilter
    });
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    //#region arrange data as parent child relation
    var tableData = [];
    filterData.data.forEach((p) => {
      var parentRow = [
        p.shipmentId ? p.shipmentId : '',
        p.carrier ? p.carrier : '',
        p.proNo ? p.proNo : '',
        p.billOfLoading ? p.billOfLoading : '',
        p.noOfBoxes ? p.noOfBoxes : '',
        p.totalWeight ? p.totalWeight : '',
        /*getmonth() + 1 ------------ because getmonth() always track from 0th index so january will be 0, feb is 1 and so on  */
        p.shipDateUIString ? (p.shipDateUIString.getMonth() + 1) + '/' + p.shipDateUIString.getDate() + '/' + p.shipDateUIString.getFullYear() : ''
      ]
      tableData.push(parentRow);
      const headerChild = [
        { text: "", style: 'tableHeader', colSpan: 2 },
        {},
        { text: "Shipment Id", style: 'tableHeader' },
        { text: "Box No", style: 'tableHeader' },
        { text: "Item", style: 'tableHeader' },
        { text: "Item Description", style: 'tableHeader' },
        { text: "Quantity", style: 'tableHeader' }
      ];
      tableData.push(headerChild);
      p.trackChildShipments.forEach(c => {
        var rowChild = [
          { text: "", colSpan: 2 },
          {},
          c.shipmentid ? c.shipmentid : "",
          c.boxno ? c.boxno : "",
          c.item ? c.item : "",
          c.itemdescription ? c.itemdescription : "",
          c.quantity ? c.quantity : ""
        ];
        tableData.push(rowChild);
      });
    })
    // #endregion
    let docShipmentDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: 'Track Shipment', alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          columns: [
            [{
              text: "Customer Number: " + this.loggedInUser.customerNumber,
              bold: true,
              margin: [0, 15, 0, 15]
            },
            {
              text: "Customer Name: " + this.loggedInUser.customerName,
              bold: true,
              margin: [0, 15, 0, 15]
            }],
            [{
              text: "SO#: " + this.orderDetailsHeaderData.orderNumber,
              margin: [0, 2, 0, 2]
            },
            {
              text: "PO#: " + this.OrderDetailsData.poNumber,
              margin: [0, 2, 0, 2]
            },
            {
              text: "Shipping From: " + this.OrderDetailsData.shipFrom,
              margin: [0, 2, 0, 2]
             },
            {
              text: "Job Name: " + this.orderDetailsHeaderData.jobName,
              margin: [0, 2, 0, 2]
              },
            {
              text: "Job Number: " + this.orderDetailsHeaderData.jobNumber,
              margin: [0, 2, 0, 2]
            },
            {
              text: "Order Date: " + this.orderDetailsHeaderData.orderDateUIString,
              margin: [0, 2, 0, 2]
            },
            {
              text: "CSC Name: " + this.orderDetailsHeaderData.cscName,
              margin: [0, 2, 0, 2]
            },
            {
              text: "CSC Phone: " + this.orderDetailsHeaderData.cscPhone,
              margin: [0, 2, 0, 2]
            }]
          ],
        },
        {
          text: "Track Shipment",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            body: [
              [
                { text: this.orderDetailTxt.shipmentIdLbl ? this.orderDetailTxt.shipmentIdLbl : this.orderDetail.shipmentIdLbl, style: 'tableHeader' },
                { text: this.orderDetailTxt.carrierLbl ? this.orderDetailTxt.carrierLbl : this.orderDetail.carrierLbl, style: 'tableHeader' },
                { text: this.orderDetailTxt.proNoLbl ? this.orderDetailTxt.proNoLbl : this.orderDetail.proNoLbl, style: 'tableHeader' },
                { text: this.orderDetailTxt.billOfLading ? this.orderDetailTxt.billOfLading : this.orderDetail.billOfLading, style: 'tableHeader' },
                { text: this.orderDetailTxt.noOfBoxesLbl ? this.orderDetailTxt.noOfBoxesLbl : this.orderDetail.noOfBoxesLbl, style: 'tableHeader' },
                { text: this.orderDetailTxt.totalWeightLbl ? this.orderDetailTxt.totalWeightLbl : this.orderDetail.totalWeightLbl, style: 'tableHeader' },
                { text: this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl, style: 'tableHeader' }
              ],
              //...this.trackShipmentGridData.map(p =>
              //  ([
              //    p.shipmentId ? p.shipmentId : '', 
              //    p.carrier ? p.carrier : '',
              //    p.proNo ? p.proNo : '',
              //    p.billOfLanding ? p.billOfLanding : '',
              //    p.noOfBoxes ? p.noOfBoxes : '',
              //    p.totalWeight ? p.totalWeight : '',
              //    p.shipDateUIString ? p.shipDateUIString : '',

              //  ])
              //)
              ...tableData
            ]
          }

        }
      ],
      footer: {
        columns: [
          { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docShipmentDefinition).download('Shipment.pdf');
    this.loadingPDF = false;
  }

  generateShipmentExcel() {
    this.loadingExcel = true;
    var currFilter = this.trackShipmentGridstate.filter;
    var filterData = process(this.trackShipmentGridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Track Shipment');
    const header = [
      this.orderDetailTxt.shipmentIdLbl ? this.orderDetailTxt.shipmentIdLbl : this.orderDetail.shipmentIdLbl,
      this.orderDetailTxt.carrierLbl ? this.orderDetailTxt.carrierLbl : this.orderDetail.carrierLbl,
      this.orderDetailTxt.proNoLbl ? this.orderDetailTxt.proNoLbl : this.orderDetail.proNoLbl,
      this.orderDetailTxt.billOfLading ? this.orderDetailTxt.billOfLading : this.orderDetail.billOfLading,
      this.orderDetailTxt.noOfBoxesLbl ? this.orderDetailTxt.noOfBoxesLbl : this.orderDetail.noOfBoxesLbl,
      this.orderDetailTxt.totalWeightLbl ? this.orderDetailTxt.totalWeightLbl : this.orderDetail.totalWeightLbl,
      this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl];
    const headerChild = [
      "",
      "Shipment Id",
      "Box No",
      "Item",
      "Item Description",
      "Quantity"
    ];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow(['', '', '', '', "SO#: " + this.orderDetailsHeaderData.orderNumber]);
    worksheet.addRow(['', '', '', '', "PO#: " + this.OrderDetailsData.poNumber]);
    worksheet.addRow(['Customer Number:' + this.loggedInUser.customerNumber + '', '', '', '', "Shipping From: " + this.OrderDetailsData.shipFrom]);
    worksheet.addRow(['', '', '', '', "Job Name: " + this.orderDetailsHeaderData.jobName]);
    worksheet.addRow(['', '', '', '', "Job Number: " + this.orderDetailsHeaderData.jobNumber]);
    worksheet.addRow(['Customer Name:' + this.loggedInUser.customerName + '', '', '', '', "Order Date: " + this.orderDetailsHeaderData.orderDateUIString]);
    worksheet.addRow(['', '', '', '', "CSC Name: " + this.orderDetailsHeaderData.cscName]);
    worksheet.addRow(['', '', '', '', "CSC Phone: " + this.orderDetailsHeaderData.cscPhone]);
    //let ClientIdRow = worksheet.addRow(['Customer Number :' + this.loggedInUser.customerNumber + '']);
    //ClientIdRow.font = { size: 10, bold: true }
    //worksheet.addRow([]);
    //let ClientNameRow = worksheet.addRow(['Customer Name :' + this.loggedInUser.customerName + '']);
    //ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.columns[0].width = 40;

    let invoiceDetailsRow = worksheet.addRow(['Track Shipment']);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.forEach(p => {
      var parentRow = [
        p.shipmentId ? p.shipmentId : '',
        p.carrier ? p.carrier : '',
        p.proNo ? p.proNo : '',
        p.billOfLoading ? p.billOfLoading : '',
        p.noOfBoxes ? p.noOfBoxes : '',
        p.totalWeight ? p.totalWeight : '',
        p.shipDateUIString ? (p.shipDateUIString.getMonth() + 1) + '/' + p.shipDateUIString.getDate() + '/' + p.shipDateUIString.getFullYear() : ''
      ];
      let row = worksheet.addRow(parentRow);
      //Add Child Header row
      let headerChildRow = worksheet.addRow(headerChild);

      // Cell Style : Fill and Border
      headerChildRow.eachCell((cell, number) => {
        if (number > 1) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCFFE5' },
            bgColor: { argb: 'FF0000FF' }
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        }
      })
      p.trackChildShipments.forEach(c => {
        let rowChild = worksheet.addRow([
          "",
          c.shipmentid ? c.shipmentid : "",
          c.boxno ? c.boxno : "",
          c.item ? c.item : "",
          c.itemdescription ? c.itemdescription : "",
          c.quantity ? c.quantity : ""
        ]);
      });
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'TrackShipment.xlsx');
    })
    this.loadingExcel = false;
  }

  //#endregion
  //#region grid state save
  public onShipmentReorder(e: any): void {
    const reorderedColumn = this.gridShipmentSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridShipmentSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  public onShipmentVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.gridShipmentSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });
    this.saveTrackShipmentGrid();
  }

  public saveTrackShipmentGrid(): void {
    const gridConfig = {
      columnsConfig: this.gridShipmentSettings.columnsConfig,
      state: this.gridShipmentSettings.state
    };
    this.persistingService.set(this.loggedInUser.userName + 'trackShipmentGridSettings', gridConfig);
  }

  public invoiceShipmentGridSettings(gridShipmentSettings: GridSettings): GridSettings {
    const state = gridShipmentSettings.state;
    this.mapShipmentDateFilter(state.filter);

    return {
      state,
      columnsConfig: gridShipmentSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.orderDetailsGridData, state)
    };
  }
  public mapShipmentDateFilter = (descriptor: any) => {
    const filters = descriptor.filters || [];

    filters.forEach(filter => {
      if (filter.filters) {
        this.mapDateFilter(filter);
      }
    });
  }
  //#endregion
  //#endregion
  //#region Grid Helper
  public hideOrderTotal: boolean = false;
  public get orderTotal(): number {
    this.hideOrderTotal = false;
    if (this.orderDetailsGridData) {
      this.orderDetailsGridData.forEach(d => {
        if (d.listPrice == '-0.001') {
          this.hideOrderTotal = true;
        }
      });
      return (this.orderDetailsGridData as IOrderInquiryDetails[]).map(
        item => item.extendedPrice
      ).reduce((a, b) => a + b, 0);
    }
    return 0;
  }
  //#endregion
  checkInvoiceInquiryAccessForLoggedInUser() {
    this.hasInvoiceInquiryAccess = this.userService.hasAccessToInvoiceInquiry();
  }

  initializeGridHeader() {

    this.gridSettings.columnsConfig.forEach((el) => {
      if (el.field == 'lineNumber') {
        el.title = this.orderDetailTxt.lineLbl ? this.orderDetailTxt.lineLbl : this.orderDetail.lineLbl;
      }
      if (el.field == 'scheduleDateAsDate') {
        el.title = this.orderDetailTxt.scheduleDateLbl ? this.orderDetailTxt.scheduleDateLbl : this.orderDetail.scheduleDateLbl;

      }

      if (el.field == 'itemNumber') {
        el.title = this.orderDetailTxt.itemLbl ? this.orderDetailTxt.itemLbl : this.orderDetail.itemLbl;
      }


      if (el.field == 'quantity') {
        el.title = this.orderDetailTxt.qtyLbl ? this.orderDetailTxt.qtyLbl : this.orderDetail.qtyLbl;
      }

      if (el.field == 'uom') {
        el.title = this.orderDetailTxt.uomLbl ? this.orderDetailTxt.uomLbl : this.orderDetail.uomLbl;
      }

      if (el.field == 'orderDateAsDate') {
        el.title = this.orderDetailTxt.orderDateLbl ? this.orderDetailTxt.orderDateLbl : this.orderDetail.orderDateLbl;
      }

      if (el.field == 'paint') {
        el.title = this.orderDetailTxt.paintLbl ? this.orderDetailTxt.paintLbl : this.orderDetail.paintLbl;
      }

      if (el.field == 'description') {
        el.title = this.orderDetailTxt.itemDescLbl ? this.orderDetailTxt.itemDescLbl : this.orderDetail.itemDescLbl;
      }

      if (el.field == 'status') {
        el.title = this.orderDetailTxt.statusLbl ? this.orderDetailTxt.statusLbl : this.orderDetail.statusLbl;
      }

      if (el.field == 'shipDateAsDate') {
        el.title = this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl;
      }


      if (el.field == 'listPrice') {
        el.title = this.orderDetailTxt.listPriceLbl ? this.orderDetailTxt.listPriceLbl : this.orderDetail.listPriceLbl;
      }

      if (el.field == 'cmp') {
        el.title = this.orderDetailTxt.multiplierLbl ? this.orderDetailTxt.multiplierLbl : this.orderDetail.multiplierLbl;
      }


    });

    //Invoice grid
    this.gridInvoiceSettings.columnsConfig.forEach((el) => {
      if (el.field == 'invoiceNumber') {
        el.title = this.orderDetailTxt.invoiceNumberLbl ? this.orderDetailTxt.invoiceNumberLbl : this.orderDetail.invoiceNumberLbl;

      }

      if (el.field == 'lineNumber') {
        el.title = this.orderDetailTxt.lineLbl ? this.orderDetailTxt.lineLbl : this.orderDetail.lineLbl;

      }

      if (el.field == 'orderType') {
        el.title = this.orderDetailTxt.orderTypeLbl ? this.orderDetailTxt.orderTypeLbl : this.orderDetail.orderTypeLbl;

      }

      if (el.field == 'quantity') {
        el.title = this.orderDetailTxt.qtyLbl ? this.orderDetailTxt.qtyLbl : this.orderDetail.qtyLbl;

      }

      if (el.field == 'uom') {
        el.title = this.orderDetailTxt.invoiceNumberLbl ? this.orderDetailTxt.invoiceNumberLbl : this.orderDetail.uomLbl;

      }

      if (el.field == 'itemNumber') {
        el.title = this.orderDetailTxt.itemLbl ? this.orderDetailTxt.itemLbl : this.orderDetail.itemLbl;

      }

      if (el.field == 'itemDescription') {
        el.title = this.orderDetailTxt.descriptionLbl ? this.orderDetailTxt.descriptionLbl : this.orderDetail.descriptionLbl;

      }

      if (el.field == 'unitPrice') {
        el.title = this.orderDetailTxt.unitPriceLbl ? this.orderDetailTxt.unitPriceLbl : this.orderDetail.unitPriceLbl;

      }

      if (el.field == 'extendedPrice') {
        el.title = this.orderDetailTxt.extendedPriceLbl ? this.orderDetailTxt.extendedPriceLbl : this.orderDetail.extendedPriceLbl;

      }


      if (el.field == 'shipFrom') {
        el.title = this.orderDetailTxt.shipFromLbl ? this.orderDetailTxt.shipFromLbl : this.orderDetail.shipFromLbl;

      }

      if (el.field == 'status') {
        el.title = this.orderDetailTxt.statusLbl ? this.orderDetailTxt.statusLbl : this.orderDetail.statusLbl;

      }

    });

    // shipment grid
    this.gridShipmentSettings.columnsConfig.forEach((el) => {
      if (el.field == 'shipmentId') {
        el.title = this.orderDetailTxt.shipmentIdLbl ? this.orderDetailTxt.shipmentIdLbl : this.orderDetail.shipmentIdLbl;

      }
      if (el.field == 'carrier') {
        el.title = this.orderDetailTxt.carrierLbl ? this.orderDetailTxt.carrierLbl : this.orderDetail.carrierLbl;

      }
      if (el.field == 'proNo') {
        el.title = this.orderDetailTxt.proNoLbl ? this.orderDetailTxt.proNoLbl : this.orderDetail.proNoLbl;

      }
      if (el.field == 'billOfLoading') {
        el.title = this.orderDetailTxt.billOfLading ? this.orderDetailTxt.billOfLading : this.orderDetail.billOfLading;

      }
      if (el.field == 'noOfBoxes') {
        el.title = this.orderDetailTxt.noOfBoxesLbl ? this.orderDetailTxt.noOfBoxesLbl : this.orderDetail.noOfBoxesLbl;

      }
      if (el.field == 'totalWeight') {
        el.title = this.orderDetailTxt.totalWeightLbl ? this.orderDetailTxt.totalWeightLbl : this.orderDetail.totalWeightLbl;

      }
      if (el.field == 'shipDateUIString') {
        el.title = this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl;

      }

    });

  }

  //#region pwa filter for Track shipment 
  public onFilterTrackShipment(inputValue: string): void {
    if (this.trackShipmentGridData.length > 0) {
      this.trackShipmentTabGridData = process(this.trackShipmentGridData, {
        filter: {
          logic: "or",
          filters: [
            {
              field: "shipmentId",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "carrier",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "proNo",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "billOfLoading",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "noOfBoxes",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "totalWeight",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "shipDateUIString",
              operator: "contains",
              value: inputValue,
            }
          ],
        },
      });
      if (!inputValue) {
        this.trackShipmentGridstate.skip = 0;
        this.trackShipmentGridstate.take = 10;
        this.loadTrackShipmentGridData();
      }
    }

  }
  //#endregion
  setTabPosition(position) {
    this.position4 = position;
  }
}
